<script>
import { mapActions, mapState } from 'vuex'
import VueMarkdown from 'vue-markdown'

export default {
  name: 'articles-page',
  components: {
    markdown: VueMarkdown
  },
  data () {
    return {
      article: null
    }
  },
  computed: {
    ...mapState([
      'contentMap',
      'contentSlugMap'
    ]),
    slug () {
      return this.$route.params.articleSlug
    },
    id () {
      return this.contentSlugMap[ this.slug ]
    }
  },
  created () {
    this.fetchArticle()
  },
  watch: {
    '$route': 'fetchArticle'
  },
  methods: {
    ...mapActions([
      'aFetchSingleContent'
    ]),
    fetchArticle () {
      this.aFetchSingleContent(this.slug)
        .then(() => {
          this.loadng = false
          this.article = this.contentMap[ this.id ]
        })
    }
  }
}
</script>

<template>
  <el-main>
    <el-row>
      <article class="articles articles-page">
        <header>
          <h1>{{ article.title }}</h1>
          <section class="meta">Data publikacji<br>{{ article.published | format_datetime('D MMMM YYYY') }}</section>
        </header>
        <main class="markdown">
          <markdown>{{ article.content }}</markdown>
        </main>
      </article>
    </el-row>
  </el-main>
</template>

<style lang="sass">
@import "~element-theme-chalk/src/common/var.scss"

.articles-page
  margin: 0 3hv
  width: auto

  & .markdown
    font-size: 1.1rem
    line-height: 1.45

    & p
      line-height: 1.45

    & img
      display: block
      width: 80%
      margin: 2rem auto

  & header
    align-items: flex-end
    border-bottom: 1px solid $--border-color-light
    display: flex
    flex-flow: row wrap
    justify-content: space-between
    padding-bottom: .5rem
    width: 100%

    & h1
      width: auto

    & .meta
      color: $--color-info
      font-size: .8rem
      margin-left: 1rem
      padding: .3rem 0
      text-align: right
</style>



// WEBPACK FOOTER //
// src/components/articles-page.vue